import { React, useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { ChevronRightIcon, DownloadIcon } from "@heroicons/react/outline";
import { StarIcon } from "@heroicons/react/solid";
import { LoginContext } from "../../../contexts/LoginContext";
import routes from "../../../config/routes-config";
import { ProjectDetailsModal } from "../../../components/project/ProjectDetailsModal";
import Loading from "../../../components/Loading";
import { fetchProjectData, downloadFile } from "./api-handlers";

export const ProjectDetailsPage = () => {
  const { userAuthStatus, user } = useContext(LoginContext);
  const { projectId } = useParams();

  const [isDetailsModalOpened, setDetailsModalOpened] = useState(false);
  const [projectData, setProjectData] = useState(null);

  useEffect(() => {
    if (userAuthStatus && user !== null) {
      const url = routes.project.projectDetails + "?projectId=" + projectId;
      fetchProjectData(url, projectId, setProjectData, user.token);
      console.log(projectId);
    }
  }, [projectId, user, userAuthStatus]);

  return (
    <>
      {projectData ? (
        <div className="flex flex-col w-screen place-items-center">
          <div className="bg-white lg:w-full w-96 flex flex-col px-10 py-5 lg:justify-between">
            <div className="flex flex-row w-full justify-between">
              <h1 className="mb-5 text-3xl font-semibold text-[#1E1E4A]">
                {projectData.projectTitle}
              </h1>
              <button
                className="flex flex-row justify-evenly place-items-center bg-[#C5C8FF] rounded-full px-3 py-1 h-max text-[#515151]"
                onClick={() => setDetailsModalOpened(true)}
              >
                <h1 className="text-xl">{projectData.countOfStar}</h1>
                <StarIcon className="h-7" />
              </button>
              <ProjectDetailsModal
                show={isDetailsModalOpened}
                onCloseCallback={() => setDetailsModalOpened(false)}
                projectId={projectId}
              />
            </div>
            <div className="bg-gray-300 h-0.5 mb-5 w-full"></div>
            <div className="grid lg:grid-cols-3 lg:divide-x-2 lg:divide-y-0 divide-y-2 divide-gray-300 lg:min-h-[calc(110vh-12rem)] lg:h-full h-[calc(150vh)]">
              <div className="lg:col-span-2 h-full mr-5">
                <div className="grid grid-rows-8 divide-y-2 divide-gray-300 lg:w-full w-96 h-full">
                  <div className="row-span-5 flex flex-col place-items-center justify-evenly mb-4">
                    <img
                      src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                      alt="Project"
                      className="h-[calc(16.5rem)] w-[calc(22rem)] mb-4"
                    />
                    <p className="px-12 text-justify">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
                      Aenean commodo ligula eget dolor. Aenean massa. Cum sociis
                      natoque penatibus et magnis dis parturient montes,
                      nascetur rid
                    </p>
                  </div>
                  <div className="row-span-3 flex flex-col px-12 justify-center">
                    <h1 className="text-xl text-[#1C42D5] font-medium mt-4 mb-2">
                      {projectData.projectContributorId.length === 1
                        ? "Contributor"
                        : "Contributors"}
                    </h1>
                    {projectData.projectContributorId.map(
                      (contributorId, index) => (
                        <div
                          key={contributorId}
                          className="flex flex-row justify-between place-items-center px-5 bg-[#E7E7E7] h-8 w-full rounded-md mt-2"
                        >
                          <div className="flex flex-row place-items-center text-[#616161]">
                            <img
                              src={projectData.projectContributorImages[index]}
                              alt="Profile"
                              className="h-6 w-6 rounded-full mr-4"
                            />
                            <div>
                              {projectData.projectContributorNames[index]}
                            </div>
                          </div>
                          <div>
                            <ChevronRightIcon className="h-5 text-[#7B7B7B]" />
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className="lg:col-span-1 h-full">
                <div className="grid grid-rows-2 divide-y-2 divide-gray-300 lg:w-full w-96 h-full lg:ml-5 lg:pr-5">
                  <div className="row-span-1 flex flex-col justify-evenly py-5 lg:py-0">
                    <div className="flex flex-col place-items-center lg:place-items-start">
                      <h1 className="text-xl text-[#1C42D5] font-medium">
                        Domain
                      </h1>
                      <h1 className="text-[#666666]">
                        {projectData.projectDomain}
                      </h1>
                    </div>
                    <div className="flex flex-col place-items-center lg:place-items-start">
                      <h1 className="text-xl text-[#1C42D5] font-medium mb-2">
                        Technology
                      </h1>
                      <div className="flex flex-row flex-wrap w-5/6 text-[#555555] text-sm justify-center lg:justify-start">
                        {projectData.projectTags.map((tag, index) => (
                          <h1
                            key={index}
                            className="mb-1 mr-1 px-2 border border-[#B2B7FF] rounded-full"
                          >
                            {tag}
                          </h1>
                        ))}
                      </div>
                    </div>
                    <div className="flex flex-row justify-center lg:justify-start">
                      <button
                        onClick={() =>
                          downloadFile(
                            projectData.paperUrl,
                            projectData.projectTitle
                              .replace(/\s+/g, "-")
                              .toLowerCase(),
                            ".docx"
                          )
                        }
                        className="w-24 hover:bg-white bg-[#5C5CC0] text-white font-semibold hover:text-[#5C5CC0] mr-2 px-2 border border-[#5C5CC0] rounded-lg"
                      >
                        <div className="flex flex-row items-center justify-center">
                          <h1>Paper</h1>
                          <DownloadIcon className="ml-2 h-4" />
                        </div>
                      </button>
                      <button className="w-24 hover:bg-white bg-[#5C5CC0] text-white font-semibold hover:text-[#5C5CC0] mr-2 px-2 border border-[#5C5CC0] rounded-lg">
                        <div className="flex flex-row items-center justify-center">
                          <h1>PPT</h1>
                          <DownloadIcon className="ml-2 h-4" />
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="row-span-1 flex flex-col justify-start py-8">
                    <div className="flex flex-col place-items-center lg:place-items-start">
                      <h1 className="text-xl text-[#1C42D5] font-medium">
                        Guide
                      </h1>
                      <div className="flex flex-row mt-4 place-items-center">
                        <img
                          src={projectData.projectGuideImageUrl}
                          alt="Guide"
                          className="h-8 w-8 rounded-full mr-2"
                        />
                        <h1 className="text-[#666666]">
                          {projectData.projectGuideName}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
